export default "__VITE_ASSET__BafwSg6x__"